var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubwalletLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#080120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9319 52.9999C55.9319 52.9999 48.7685 62.9999 39.9319 62.9999C31.0954 62.9999 23.9319 52.9999 23.9319 52.9999C23.9319 52.9999 31.0954 42.9999 39.9319 42.9999C48.7685 42.9999 55.9319 52.9999 55.9319 52.9999Z",
    fill: "#080120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6516 53.122C24.6174 53.0781 24.5859 53.0374 24.5571 52.9999C24.5859 52.9625 24.6174 52.9218 24.6516 52.8779C24.8601 52.6103 25.1692 52.2262 25.5679 51.7645C26.366 50.8404 27.5204 49.6089 28.9451 48.3787C31.8102 45.9049 35.6948 43.5003 39.9318 43.5003C44.1689 43.5003 48.0534 45.9049 50.9185 48.3787C52.3433 49.6089 53.4977 50.8404 54.2958 51.7645C54.6945 52.2262 55.0035 52.6103 55.2121 52.8779C55.2463 52.9217 55.2778 52.9625 55.3066 52.9999C55.2778 53.0374 55.2463 53.0781 55.2121 53.122C55.0035 53.3896 54.6945 53.7737 54.2958 54.2354C53.4977 55.1595 52.3433 56.391 50.9185 57.6212C48.0534 60.095 44.1689 62.4995 39.9318 62.4995C35.6948 62.4995 31.8102 60.095 28.9451 57.6212C27.5204 56.391 26.366 55.1595 25.5679 54.2354C25.1692 53.7737 24.8601 53.3896 24.6516 53.122V53.122Z",
    stroke: "#080120",
    strokeWidth: 1.00078
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1184 35.9654L53.1108 28.033L24 12.947V35.9577L42.6361 45.9132L49.4461 42.9128L28.9396 32.0336L28.9549 23.3149L53.1184 35.9654Z",
    fill: "url(#paint0_linear_28_34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3146 26.6435V29.3538L28.9168 32.0946L28.9626 23.2079L35.3146 26.6435Z",
    fill: "url(#paint1_linear_28_34)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3379 49.1274L49.4466 42.9129L28.9401 32.087L35.2768 29.3539L61.6389 43.1267L35.3914 54.5785L35.3379 49.1274Z",
    fill: "url(#paint2_linear_28_34)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9627 47.2874L35.2612 44.5695L35.3987 54.5709L61.6389 43.1265V51.662L28.9093 66L28.9627 47.2874Z",
    fill: "url(#paint3_linear_28_34)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44.707L28.9396 47.2875L28.9091 65.9694L24 63.5032V44.707Z",
    fill: "url(#paint4_linear_28_34)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2375 41.9281L35.261 44.5697L28.9396 47.2876L24 44.7071L30.2375 41.9281Z",
    fill: "url(#paint5_linear_28_34)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6389 32.2703L61.6088 24.2845L53.1265 28.0331V35.9731L61.6389 32.2703Z",
    fill: "url(#paint6_linear_28_34)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.9471L32.5737 9L61.6231 24.2692L53.126 28.033L24 12.9471Z",
    fill: "url(#paint7_linear_28_34)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_34",
    x1: 16.7166,
    y1: 29.4301,
    x2: 68.151,
    y2: 29.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9ACEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#47C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#14C5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_34",
    x1: 32.1156,
    y1: 35.263,
    x2: 32.1156,
    y2: 15.3367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0025D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_34",
    x1: 28.9401,
    y1: 41.9662,
    x2: 81.3212,
    y2: 41.9662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEC9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E4D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A4A6B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3F57C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0025D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_34",
    x1: 18.2285,
    y1: 54.5632,
    x2: 85.2069,
    y2: 54.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#62A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1032D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28_34",
    x1: 311.928,
    y1: 1558.16,
    x2: 392.829,
    y2: 1559.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9ACEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#47C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#14C5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_28_34",
    x1: 22.7938,
    y1: 44.6078,
    x2: 45.7586,
    y2: 44.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#0025D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_28_34",
    x1: 44.9804,
    y1: 30.354,
    x2: 101.507,
    y2: 29.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0025D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_28_34",
    x1: 24,
    y1: 18.5203,
    x2: 94.1239,
    y2: 18.5203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E6D5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A7D6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#43D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#37B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2B8CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#216B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#184E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#10353F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0A2228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#061316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#010202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubwalletLogo);
export default __webpack_public_path__ + "static/media/subwallet-logo.27267baa.svg";
export { ForwardRef as ReactComponent };